import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'stbyParseJson',
    standalone: true,
})
export class ParseJsonPipe implements PipeTransform {
    transform(value: string): any {
        return JSON.parse(value);
    }
}
